import { ModulePublishingState } from '../../../../../../@types/module-publishing-state';
import api, { ResponsePayloadWithData } from '../../../../../../api';

export type ModuleContainingUserMaterial = {
  id: string;
  catalogName: string;
  niceName: string;
  publishingState: ModulePublishingState;
  weight: number;
  subjectSlug: string;
  books: {
    id: string;
    niceName: string;
    weight: number;
  }[];
  image?: string;
};

export async function getModulesContainingUserMaterial(group: StudioGroup = 'SO') {
  const { data } = await api.get<ResponsePayloadWithData<Array<ModuleContainingUserMaterial>>>(
    '/studio/user/modules-containing-user-material',
    {
      params: {
        group,
      },
    },
  );
  return data.data;
}

export async function copyMaterial(moduleId: string, nodeId: string, materialIdsToCopy: string[]) {
  return api.post('/studio/user/user-material/copy', {
    materialIds: materialIdsToCopy,
    moduleId,
    nodeId,
  });
}
